import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import { PersonDataService } from "../../../core/persons.dataservice";
import * as dataCore from "../../../core/datacore";

@Component({
    selector: "crew-person-jobtitle",
    template: require('./person.jobtitle.component.html')
})
export class PersonJobTitleComponent {

    FromDate: Date;

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("personJobTitle") public personJobTitle: Nema.Crew.Model.PersonJob,
        @Inject("jobtitles") public jobTitles: Nema.Crew.Model.JobType[],
        private stateService: StateService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService) {
        
        this.FromDate = dataCore.addTimezoneOffset(this.personJobTitle.FromDate);
    }

    public entityName = "Person Job Title";

    public editStateName = "app.resources.persons.jobtitles.edit";

    public listStateName = "app.resources.persons.detail";

    public edit(): void {
        this.stateService.go(this.editStateName, { personJobTitleId: this.personJobTitle.Id });
    }

    public delete(): void {

        var self = this;

        this.dialog
            .open(ConfirmDialog)
            .afterClosed()
            .subscribe(res => self.onDeleteEntity(self, res));
    }

    private onDeleteEntity(self: PersonJobTitleComponent, shouldDelete?: boolean) {
        if (shouldDelete) {

            self.personDataService.removeMapping(this.personJobTitle, () => { });

            self.personDataService
                .save(self.personJobTitle.Person)
                .then(() => self.backToList())
                .catch(err => self.$log.error("Error deleting the entity.\n\nError is: " + err));
        }
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personJobTitle.PersonId });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/jobtitles/person.jobtitle.component.ts